// Shared by the spec book (placeholder TOC row) and the panel/drawer header during inline create.

/**
 * Synthetic externalId for the placeholder TOC entry — purely a stable React key and selected-
 * highlight marker. The viewer recognizes create mode via `isCreating`, not by matching this id.
 */
export const NEW_SPEC_PLACEHOLDER_EXTERNAL_ID = "__new__";

/** User-facing label for the not-yet-saved spec. */
export const NEW_SPEC_PLACEHOLDER_TITLE = "(New Specification)";
